import { getSchema, GuestInfo } from "./guest_info";

const GuestInfoForm = {
  Form: GuestInfo,
  getSchema,
};

export default GuestInfoForm;
